import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ViewLabelDialogData } from '@app/shared/components/dialogs/view-label-dialog/view-label-dialog.data';

@Component({
    selector : 'view-label-dialog',
    template: require('./view-label-dialog.component.html'),
    styles: [require('./view-label-dialog.component.scss')]
})
export class ViewLabelDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: ViewLabelDialogData) {
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/view-label-dialog/view-label-dialog.component.ts